<script setup lang="ts">
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import type { components } from '@/api/generated/schema';

dayjs.extend(relativeTime);

type CommentDto = components['schemas']['CommentDto'];

interface Props {
  comment: CommentDto;
}
defineProps<Props>();
</script>

<template>
  <li class="flex gap-3 py-3 border-b border-border last:border-0">
    <!-- Avatar initials -->
    <div
      class="flex-shrink-0 w-8 h-8 rounded-full bg-navy-800 text-white flex items-center justify-center text-caption font-medium"
      aria-hidden="true"
    >
      {{ comment.authorName.charAt(0).toUpperCase() }}
    </div>
    <div class="flex-1 min-w-0">
      <div class="flex items-baseline gap-2 flex-wrap">
        <span class="text-body font-medium text-fg">{{ comment.authorName }}</span>
        <span class="text-caption text-muted">{{ comment.authorRole }}</span>
        <time :datetime="comment.createdAt" class="text-caption text-muted font-mono tabular-nums ml-auto">
          {{ dayjs(comment.createdAt).fromNow() }}
        </time>
      </div>
      <p class="text-body text-fg mt-1 whitespace-pre-wrap">{{ comment.body }}</p>
    </div>
  </li>
</template>
